import React, { useRef, useEffect } from 'react';

function Instructions() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const tileSize = 30;

    canvas.width = 600;
    canvas.height = 150; // Increased height to fit Mana bar

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Player
    ctx.beginPath();
    ctx.rect(0, 0, tileSize, tileSize);
    ctx.fillStyle = '#0f0';
    ctx.fill();
    ctx.strokeStyle = '#fff';
    ctx.stroke();
    ctx.fillStyle = '#fff';
    ctx.font = '12px Arial';
    ctx.fillText('Player', tileSize * 1.5, tileSize / 2 + 5);

    // Enemy
    ctx.beginPath();
    ctx.moveTo(tileSize * 3 + tileSize / 2, 0);
    ctx.lineTo(tileSize * 4, tileSize);
    ctx.lineTo(tileSize * 3, tileSize);
    ctx.closePath();
    ctx.fillStyle = '#f00';
    ctx.fill();
    ctx.strokeStyle = '#f00';
    ctx.stroke();
    ctx.fillText('Enemy', tileSize * 4.5, tileSize / 2 + 5);

    // Loot
    ctx.beginPath();
    ctx.moveTo(tileSize * 6 + tileSize / 2, 0);
    ctx.lineTo(tileSize * 6, tileSize);
    ctx.lineTo(tileSize * 7, tileSize);
    ctx.closePath();
    ctx.fillStyle = '#ff0';
    ctx.fill();
    ctx.fillText('Loot', tileSize * 7.5, tileSize / 2 + 5);

    // Exit
    ctx.beginPath();
    ctx.rect(tileSize * 9, 0, tileSize - 10, tileSize - 10);
    ctx.fillStyle = '#0ff';
    ctx.fill();
    ctx.fillText('Exit', tileSize * 10, tileSize / 2 + 5);

    // NPC
    ctx.beginPath();
    ctx.arc(tileSize * 11.5, tileSize / 2, tileSize / 3, 0, Math.PI * 2);
    ctx.fillStyle = '#00f';
    ctx.fill();
    ctx.strokeStyle = '#fff';
    ctx.stroke();
    ctx.fillText('NPC', tileSize * 12.5, tileSize / 2 + 5);

    // Stamina
    ctx.beginPath();
    ctx.rect(tileSize * 14, 0, tileSize * 2, tileSize / 2);
    ctx.fillStyle = '#ff8000';
    ctx.fillRect(tileSize * 14, 0, tileSize * 1.5, tileSize / 2);
    ctx.strokeStyle = '#fff';
    ctx.stroke();
    ctx.fillText('Stamina', tileSize * 15.5, tileSize / 4 + 5);

    // Mana
    ctx.beginPath();
    ctx.rect(tileSize * 14, tileSize / 2 + 10, tileSize * 2, tileSize / 2);
    ctx.fillStyle = '#00f';
    ctx.fillRect(tileSize * 14, tileSize / 2 + 10, tileSize * 1, tileSize / 2);
    ctx.strokeStyle = '#fff';
    ctx.stroke();
    ctx.fillText('Mana', tileSize * 15.5, tileSize / 2 + 15);

    // Rest
    ctx.beginPath();
    ctx.arc(tileSize * 17.5, tileSize / 2, tileSize / 4, 0, Math.PI * 2);
    ctx.fillStyle = '#ffff00';
    ctx.fill();
    ctx.fillStyle = '#000';
    ctx.font = '12px Arial';
    ctx.fillText('R', tileSize * 17.5 - 3, tileSize / 2 + 4);
    ctx.strokeStyle = '#fff';
    ctx.stroke();
    ctx.fillText('Rest', tileSize * 18.5, tileSize / 2 + 5);
  }, []);

  return (
    <div>
      <h3>How to Play Crypt Crawler</h3>
      <p>
        <strong>Objective:</strong> Navigate the Crypt of Shadows, defeat enemies, collect loot, and reach the exit to progress. Seek the Soulstone to end the curse or claim its power!
      </p>
      <p>
        <strong>Controls:</strong><br />
        - <strong>WASD</strong>: Move your character (green square). Costs 1 Stamina.<br />
        - <strong>Spacebar</strong>: Attack enemies (1 tile for Warrior/Rogue, 2 tiles for Mage, costs 2 Mana for Mage).<br />
        - <strong>E</strong>: Pick up loot (yellow triangle) when standing on it.<br />
        - <strong>R</strong>: Rest to recover Stamina and Mana (5 seconds, vulnerable).<br />
        - <strong>T</strong>: Interact with NPC (blue circle) when adjacent.<br />
        - <strong>B</strong>: Use a bomb from inventory if an enemy is in range.<br />
        - <strong>I</strong>: Cycle through inventory items.<br />
        - <strong>U</strong>: Use/equip selected item (e.g., heal, restore Mana, equip gear).<br />
        - Reach the <strong>Exit</strong> (cyan square) to advance floors.
      </p>
      <p>
        <strong>Mechanics:</strong><br />
        - <strong>Stamina:</strong> Limits actions (move, attack, etc.). Regenerates 1/sec, fully with rest or Stamina Shards.<br />
        - <strong>Mana:</strong> Used by Mages (2 per attack). Regenerates 1/sec, or use Mana Potions.<br />
        - <strong>Combat:</strong> Attacks may critically hit (boosted by Luck). Enemies can be dodged.<br />
        - <strong>Critical Hits:</strong> Chance and damage increase with Critical Hit Chance and Luck.<br />
        - <strong>Dodge Chance:</strong> Avoid enemy attacks entirely.<br />
        - <strong>Status Resistance:</strong> Reduces damage from zone effects (e.g., fire, poison).<br />
        - <strong>Luck:</strong> Improves loot quality, critical hits, and drop rates.<br />
        - <strong>Inventory:</strong> Holds 5 items. Use consumables or equip gear.<br />
        - <strong>Ectoplasm:</strong> Trade with NPCs for items.<br />
        - <strong>Leveling:</strong> Gain XP to boost stats, including new ones like Luck.
      </p>
      <canvas ref={canvasRef} style={{ border: '1px solid #fff', margin: '10px 0' }} />
      <p><em>Explore the lore and master your stats to conquer the Crypt!</em></p>
    </div>
  );
}

export default Instructions;